var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPerfilCuenta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.036,
    height: 27.766,
    viewBox: "0 0 26.036 27.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7115",
    "data-name": "Group 7115",
    transform: "translate(-1202.256 -77.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5988",
    "data-name": "Path 5988",
    d: "M1275.477,83.685a6.625,6.625,0,1,1-6.637-6.611A6.608,6.608,0,0,1,1275.477,83.685Z",
    transform: "translate(-53.807 0)",
    fill: "#ced6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5989",
    "data-name": "Path 5989",
    d: "M1215.238,220.483h-8.622a4.924,4.924,0,0,1-2.528-.572,3.522,3.522,0,0,1-1.822-3.133,18.242,18.242,0,0,1,1.047-7.143,6.926,6.926,0,0,1,1.512-2.418,4.352,4.352,0,0,1,3-1.247.621.621,0,0,1,.324.115c.472.293.936.6,1.405.9a10.349,10.349,0,0,0,6.46,1.716,10.474,10.474,0,0,0,4.792-1.6c.532-.331,1.05-.683,1.587-1.006a.856.856,0,0,1,.463-.105,4.58,4.58,0,0,1,3.926,2.688,13.1,13.1,0,0,1,1.356,4.849c.1.926.14,1.863.151,2.8a3.8,3.8,0,0,1-4.041,4.154c-3,.032-6.008.007-9.012.007Z",
    transform: "translate(0 -115.648)",
    fill: "#ced6de"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPerfilCuenta);
export default __webpack_public_path__ + "static/media/ICO-PERFIL-CUENTA.3419426fee186ef817278c5fd2494e1f.svg";
export { ForwardRef as ReactComponent };